import * as React from "react";
import { RootState } from "../../redux";
import { connect, Dispatch } from "react-redux";

import API from "../../vendor/api";

import { fetchChats } from "../../redux/modules/appChats/appChats";
import { fetchContacts } from "../../redux/modules/appContacts/appContacts";
import { fetchCurrentUser } from "../../redux/modules/appAuth/appAuth";

import TextDialog from "../../components/Dialogs/TextDialog/";
import ListDoctorsDialog from "../../components/Dialogs/ListDoctorsDialog/";
import Sidebar from "../Sidebar";
import Chat from "../Chat";
import Menu from "../Menu";
import HeaderLogo from "../../components/Logos/HeaderLogo";

import { setDialogStatus } from "../../redux/modules/ui/ui";

import { IUser } from "../../types/index";

const s = require("./main.scss");

interface IMainProps {
    user: any;
    dispatch: Dispatch<any>;
    termsOfUseDialogOpen: boolean;
    doctorsDialogOpen: boolean;
};

interface IMainState {
    termsOfUse: string;
    doctors: IUser[];
};

class Main extends React.Component<IMainProps, IMainState> {
    constructor(props:IMainProps, context: any) {
        super(props, context);

        this.state = {
            termsOfUse: "",
            doctors: []
        };
    }

    componentWillMount() {
        this.props.dispatch(fetchCurrentUser());
        this.props.dispatch(fetchContacts());
        this.props.dispatch(fetchChats());
        // this.props.dispatch(fetchContacts());

        API.termosDeUso().then(res => {
            this.setState({
                termsOfUse: res
            } as any);
        });

        API.getAllDoctors({}, 0).then(doctors => {
            this.setState({
                doctors
            } as any);
        });
    }

    closeCreateTermsOfUseDialog() {
        this.props.dispatch(setDialogStatus("termsOfUseDialog", false));
    }

    closeListDoctorsDialog() {
        this.props.dispatch(setDialogStatus("doctorsDialog", false));
    }

    public render(): JSX.Element {
        return (
            <div className={s.main}>
                <header>
                    <HeaderLogo />
                    <Menu />
                </header>
                <div className={s.sidebarChat}>
                    <Sidebar />
                    <Chat />
                </div>

                {
                    this.props.termsOfUseDialogOpen ?
                        <TextDialog
                            title={"Termos de uso"}
                            text={this.state.termsOfUse}
                            onCloseDialog={this.closeCreateTermsOfUseDialog.bind(this)}
                        />
                    : null
                }

                {
                    this.props.doctorsDialogOpen ?
                        <ListDoctorsDialog
                            doctors={this.state.doctors}
                            onCloseDialog={this.closeListDoctorsDialog.bind(this)}
                        />
                    : null
                }
            </div>
        );
    }
}

export default connect((state: RootState) => ({
    user: state.auth.user,
    termsOfUseDialogOpen: state.ui.dialogs.termsOfUseDialog,
    doctorsDialogOpen: state.ui.dialogs.doctorsDialog
}))(Main);



// WEBPACK FOOTER //
// ./src/containers/Main/index.tsx